module.exports = __webpack_public_path__ + "img/donkey-kong.17bb0c92.png";